import { HTTP_URL } from "../config/backend";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";
import { CheckCircle2, Phone, Mail, Building2, Coffee, GraduationCap, Heart, Briefcase } from "lucide-react";

const API = HTTP_URL;

const USECASES = [
  { icon: Coffee,         color: "#ff8c00", title: "Кафе и рестораны",       desc: "Превратите пятничный вечер в событие. Гости играют прямо за столиками — телефоны в руках, один экран на весь зал.", examples: ["Игровые вечера по пятницам", "Квизы для постоянных гостей", "Корпоративные банкеты"] },
  { icon: Building2,      color: "#00f5ff", title: "Корпоративы и команды",  desc: "Icebreaker для новой команды, активность на стратсессии или просто пятничный релакс. Без установки приложений.", examples: ["Онбординг новых сотрудников", "Тимбилдинг на выезде", "Пятничные посиделки"] },
  { icon: GraduationCap,  color: "#9b5de5", title: "Образование и тренинги", desc: "Викторина вместо скучного теста, голосование вместо поднятых рук. Вовлечённость — совсем другой уровень.", examples: ["Проверка знаний в классе", "Интерактивные лекции", "Тренинги и воркшопы"] },
  { icon: Heart,          color: "#ff3cac", title: "Мероприятия и события",   desc: "День рождения, свадьба, выпускной — любое событие станет незабываемым. Гости не просто сидят, они участвуют.", examples: ["Дни рождения и юбилеи", "Свадебные вечеринки", "Выпускные и встречи"] },
];

export default function BusinessPage() {
  const navigate = useNavigate();
  const [form,    setForm]    = useState({ name: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [err,     setErr]     = useState("");

  const send = async () => {
    if (!form.name.trim() || !form.phone.trim()) { setErr("Укажи имя и контакт."); return; }
    setSending(true); setErr("");
    try {
      await axios.post(`${API}/api/contact`, form);
      setSent(true);
    } catch {
      setErr("Не удалось отправить. Напишите напрямую на почту.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* HERO */}
        <div style={{ textAlign: "center", marginBottom: "4rem" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
            <Crewmate color="#ffe600" size={44} animate="wiggle" />
            <Crewmate color="#ff3cac" size={56} animate="bounce" />
            <Crewmate color="#00f5ff" size={44} animate="wiggle" />
          </div>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.5rem",
            background: "#ffe600", border: "2.5px solid #000",
            borderRadius: "9999px", boxShadow: "3px 3px 0 #000",
            padding: "0.35rem 1.25rem", marginBottom: "1.25rem",
            fontFamily: "'Fredoka One', sans-serif", fontSize: "0.9rem", color: "#000",
          }}>
            <Briefcase style={{ width: "1rem", height: "1rem" }} /> Для бизнеса и мероприятий
          </div>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(2rem, 6vw, 3.5rem)",
            lineHeight: 1.1, color: "#fff", marginBottom: "1.25rem",
            textShadow: "4px 4px 0 #ffe600, 8px 8px 0 #000",
          }}>
            СДЕЛАЙ ЛЮБОЕ СОБЫТИЕ<br/>
            <span style={{ color: "#ffe600" }}>НЕЗАБЫВАЕМЫМ</span>
          </h1>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "1.1rem", color: "#bbb", maxWidth: "560px", margin: "0 auto 2rem", lineHeight: 1.75 }}>
            NeonParty превращает любую компанию в игровую площадку.
            Телефоны — пульты, один экран — игровое поле.
            <strong style={{ color: "#fff" }}> Без установок. Без регистрации.</strong>
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/pro")} className="btn-cartoon btn-accent" style={{ padding: "0.85rem 2rem", fontSize: "1.05rem" }}>
              🎮 Попробовать сейчас
            </button>
            <a href="tel:+79106001297" className="btn-cartoon" style={{ padding: "0.85rem 2rem", fontSize: "1.05rem", background: "#1a0035", color: "#9b5de5", border: "2.5px solid #000", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
              <Phone style={{ width: "1rem", height: "1rem" }} /> Позвонить
            </a>
          </div>
        </div>

        {/* ЧТО УМЕЕТ */}
        <section style={{ marginBottom: "3rem" }}>
          <div className="card-cartoon">
            <h2 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.3rem", color: "#9b5de5", textAlign: "center", marginBottom: "1.5rem" }}>
              ЧТО УМЕЕТ NEONPARTY
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "0.75rem" }}>
              {[
                { emoji: "🎮", text: "32 игры — от серьёзных квизов до безумных активностей" },
                { emoji: "📱", text: "Не нужно ничего скачивать — только браузер на телефоне" },
                { emoji: "👥", text: "До 16 игроков одновременно, в зависимости от игры" },
                { emoji: "🔍", text: "Интерактивные квесты с развилками и голосованием" },
                { emoji: "🎵", text: "Угадай мелодию, крокодил, рисовалка и многое другое" },
                { emoji: "⚡", text: "Запуск за 30 секунд — просто покажи код на экране" },
              ].map((f, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
                  <div style={{
                    background: ["#ff3cac","#00f5ff","#ffe600","#3dffa0","#9b5de5","#ff8c00"][i],
                    border: "2px solid #000", borderRadius: "0.5rem", boxShadow: "2px 2px 0 #000",
                    width: "2rem", height: "2rem", flexShrink: 0,
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem",
                  }}>{f.emoji}</div>
                  <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", color: "#ccc", margin: 0, lineHeight: 1.5, paddingTop: "0.2rem" }}>{f.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* КТО УЖЕ ИГРАЕТ */}
        <section style={{ marginBottom: "3rem" }}>
          <h2 style={{
            fontFamily: "'Fredoka One', sans-serif", fontSize: "1.75rem",
            color: "#ffe600", textAlign: "center", marginBottom: "0.5rem",
            textShadow: "3px 3px 0 #ff8c00, 5px 5px 0 #000",
          }}>КТО УЖЕ ИГРАЕТ</h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.88rem", color: "#555", textAlign: "center", marginBottom: "1.75rem" }}>
            NeonParty подходит для любой ситуации где собирается компания
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "1rem" }}>
            {USECASES.map((u, i) => {
              const Icon = u.icon;
              return (
                <div key={i} className="card-cartoon" style={{ padding: "1.5rem" }}>
                  <div style={{
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    background: u.color, border: "2.5px solid #000",
                    borderRadius: "0.9rem", boxShadow: "3px 3px 0 #000",
                    width: "3rem", height: "3rem", marginBottom: "0.85rem",
                  }}>
                    <Icon style={{ width: "1.4rem", height: "1.4rem", color: "#000" }} />
                  </div>
                  <h3 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem", color: "#fff", marginBottom: "0.5rem" }}>{u.title}</h3>
                  <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#999", lineHeight: 1.6, marginBottom: "0.75rem" }}>{u.desc}</p>
                  {u.examples.map((ex, j) => (
                    <div key={j} style={{ display: "flex", alignItems: "center", gap: "0.4rem", marginBottom: "0.2rem" }}>
                      <CheckCircle2 style={{ width: "0.8rem", height: "0.8rem", color: u.color, flexShrink: 0 }} />
                      <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem", color: "#777" }}>{ex}</span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </section>

        {/* ИНДИВИДУАЛЬНЫЕ РЕШЕНИЯ */}
        <section className="card-cartoon" style={{ marginBottom: "3rem", textAlign: "center" }}>
          <div style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>🤝</div>
          <h2 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.5rem", color: "#ffe600", marginBottom: "0.75rem" }}>
            ИНДИВИДУАЛЬНЫЕ РЕШЕНИЯ
          </h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.95rem", color: "#bbb", maxWidth: "580px", margin: "0 auto 1.5rem", lineHeight: 1.75 }}>
            Нужно что-то особенное? Разработаем решение под вас — брендированный интерфейс, квест с вашим сюжетом, уникальные вопросы про вашу компанию.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.6rem", justifyContent: "center", marginBottom: "1.75rem" }}>
            {["🎨 Брендинг","❓ Своя база вопросов","🔍 Квест с вашим сюжетом","📊 Аналитика","🔒 Закрытый доступ","🎁 Интеграция с наградами"].map((item, i) => (
              <span key={i} style={{
                background: ["#ff3cac","#00f5ff","#ffe600","#3dffa0","#9b5de5","#ff8c00"][i],
                color: "#000", border: "2px solid #000", borderRadius: "0.5rem",
                boxShadow: "2px 2px 0 #000", padding: "0.3rem 0.75rem",
                fontFamily: "'Fredoka One', sans-serif", fontSize: "0.82rem",
              }}>{item}</span>
            ))}
          </div>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="tel:+79106001297" className="btn-cartoon btn-accent" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "0.75rem 1.5rem", fontSize: "1rem" }}>
              <Phone style={{ width: "1rem", height: "1rem" }} /> +7 910 600-12-97
            </a>
            <a href="mailto:kuzin.denison@gmail.com" className="btn-cartoon" style={{ textDecoration: "none", background: "#9b5de5", color: "#fff", display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "0.75rem 1.5rem", fontSize: "1rem" }}>
              <Mail style={{ width: "1rem", height: "1rem" }} /> Написать на email
            </a>
          </div>
        </section>

        {/* ФОРМА */}
        <section className="card-cartoon" style={{ textAlign: "center" }}>
          <h2 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.4rem", color: "#fff", marginBottom: "0.5rem" }}>
            Есть вопросы? Напишите нам!
          </h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.88rem", color: "#666", marginBottom: "1.5rem" }}>
            Ответим в течение дня и поможем выбрать подходящий формат
          </p>

          {sent ? (
            <div style={{ background: "#001a00", border: "2.5px solid #000", boxShadow: "4px 4px 0 #3dffa0", borderRadius: "1rem", padding: "1.5rem" }}>
              <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.3rem", color: "#3dffa0" }}>✅ Сообщение отправлено!</p>
              <p style={{ fontFamily: "'Nunito', sans-serif", color: "#aaa", marginTop: "0.5rem" }}>Мы свяжемся с вами в ближайшее время.</p>
            </div>
          ) : (
            <div style={{ maxWidth: "460px", margin: "0 auto" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", marginBottom: "1rem" }}>
                {[
                  { key: "name",    placeholder: "Ваше имя",         type: "input" },
                  { key: "phone",   placeholder: "Телефон или email", type: "input" },
                  { key: "message", placeholder: "Опишите задачу (необязательно)", type: "textarea" },
                ].map(f => f.type === "textarea" ? (
                  <textarea key={f.key} value={form[f.key]} rows={3}
                    onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
                    placeholder={f.placeholder}
                    style={{ width: "100%", boxSizing: "border-box", background: "#0d0520", border: "2.5px solid #ffffff22", borderRadius: "0.75rem", color: "#fff", padding: "0.7rem 1rem", fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", outline: "none", resize: "vertical" }}
                  />
                ) : (
                  <input key={f.key} type="text" value={form[f.key]}
                    onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
                    placeholder={f.placeholder}
                    style={{ width: "100%", boxSizing: "border-box", background: "#0d0520", border: "2.5px solid #ffffff22", borderRadius: "0.75rem", color: "#fff", padding: "0.7rem 1rem", fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", outline: "none" }}
                  />
                ))}
              </div>
              {err && <p style={{ fontFamily: "'Nunito', sans-serif", color: "#ff3355", fontSize: "0.85rem", marginBottom: "0.75rem" }}>❌ {err}</p>}
              <button onClick={send} disabled={sending} className="btn-cartoon btn-accent" style={{ width: "100%", fontSize: "1.05rem", padding: "0.85rem", opacity: sending ? 0.6 : 1 }}>
                {sending ? "Отправка..." : "Отправить заявку"}
              </button>
              <div style={{ display: "flex", gap: "1.5rem", justifyContent: "center", marginTop: "1.25rem", flexWrap: "wrap" }}>
                <a href="tel:+79106001297" style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", fontFamily: "'Fredoka One', sans-serif", fontSize: "1rem", color: "#ffe600", textDecoration: "none" }}>
                  <Phone style={{ width: "1rem", height: "1rem" }} /> +7 910 600-12-97
                </a>
                <a href="mailto:kuzin.denison@gmail.com" style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", fontFamily: "'Fredoka One', sans-serif", fontSize: "1rem", color: "#9b5de5", textDecoration: "none" }}>
                  <Mail style={{ width: "1rem", height: "1rem" }} /> kuzin.denison@gmail.com
                </a>
              </div>
            </div>
          )}
        </section>

      </div>
    </div>
  );
}
